const Util = {
    calcObjectSizeFromBox3(box3) {
        const x = box3.max.x - box3.min.x;
        const y = box3.max.y - box3.min.y;
        const z = box3.max.z - box3.min.z;

        return {x, y, z};
    },
    getRandomColor() {
        return Math.floor(Math.random() * Math.floor(4294967295)); //4294967295 = 0xfffff
    }
};

export default Util;
